import { render, staticRenderFns } from "./orderServicerTransfer.vue?vue&type=template&id=49ecd922&"
import script from "./orderServicerTransfer.vue?vue&type=script&lang=ts&"
export * from "./orderServicerTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports